import React from 'react';
import XLSX from 'sheetjs-style';
import { numeroFormat, valorFormat } from './formatters';

// table_to_book interpreta el texto de cada celda como número en formato inglés: con separadores
// colombianos "1.234,50" quedaba en 1,2345 y "1,8" en 18. Las celdas numéricas guardan el valor
// real en data-valor y se exporta una copia de la tabla con ese valor en vez del texto formateado.
export const tablaALibro = table => {
    const copia = table.cloneNode(true);
    copia.querySelectorAll('[data-valor]').forEach(td => { td.textContent = td.getAttribute('data-valor'); });
    return XLSX.utils.table_to_book(copia);
};

export const CeldaValor = ({ valor, style }) =>
    <td style={{ textAlign: 'right', ...style }} data-valor={valor || 0}>{valorFormat(valor)}</td>;

export const CeldaNumero = ({ valor, style }) =>
    <td style={{ textAlign: 'right', ...style }} data-valor={valor || 0}>{numeroFormat(valor)}</td>;
